var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemporalRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.5656,
    height: 64.58,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 64.58,
    opacity: 0,
    width: 64.5656,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4818 36.1556L32.2544 36.1556C33.6475 36.1556 34.7456 35.0775 34.7456 33.6644L34.7456 13.1925C34.7456 11.7993 33.6475 10.7268 32.2544 10.7268C30.8669 10.7268 29.7887 11.7993 29.7887 13.1925L29.7887 31.1987L16.4818 31.1987C15.0687 31.1987 13.9906 32.2769 13.9906 33.6644C13.9906 35.0775 15.0687 36.1556 16.4818 36.1556ZM32.28 64.56C49.965 64.56 64.5656 49.9393 64.5656 32.28C64.5656 14.595 49.9393 0 32.2544 0C14.6006 0 0 14.595 0 32.28C0 49.9393 14.6262 64.56 32.28 64.56ZM32.28 58.2013C17.8956 58.2013 6.38433 46.6644 6.38433 32.28C6.38433 17.8956 17.87 6.35871 32.2544 6.35871C46.6387 6.35871 58.2069 17.8956 58.2069 32.28C58.2069 46.6644 46.6644 58.2013 32.28 58.2013Z",
    fill: "#ff3b30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemporalRed);
export default __webpack_public_path__ + "static/media/temporal-red.716831fbbe0cfc8b26889301049298c9.svg";
export { ForwardRef as ReactComponent };